function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_26912_10309)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.42969 5.82361H6.61852C6.94211 5.82361 7.20445 5.56126 7.20445 5.23767C7.20445 4.91408 6.94211 4.65173 6.61852 4.65173H3.42969C3.10609 4.65173 2.84375 4.91408 2.84375 5.23767C2.84375 5.56126 3.10609 5.82361 3.42969 5.82361Z",
  fill: "#23335B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.39977 6.99536H3.42969C3.10609 6.99536 2.84375 7.2577 2.84375 7.5813C2.84375 7.90489 3.10609 8.16724 3.42969 8.16724H7.39977C7.72336 8.16724 7.9857 7.90489 7.9857 7.5813C7.9857 7.2577 7.72336 6.99536 7.39977 6.99536Z",
  fill: "#23335B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.9141 7.29623H11.5218V2.80408C11.5218 2.48048 11.2595 2.21814 10.9359 2.21814H1.08594C0.762344 2.21814 0.5 2.48048 0.5 2.80408V10.0149C0.5 10.3385 0.762344 10.6008 1.08594 10.6008H8.28902L9.47801 11.6305V17.196C9.47801 17.4254 9.61184 17.6336 9.82047 17.729C9.8984 17.7646 9.98137 17.7819 10.0638 17.7819C10.2021 17.7819 10.3389 17.733 10.4475 17.6389L12.7108 15.6789H19.9141C20.2377 15.6789 20.5 15.4165 20.5 15.0929V7.88216C20.5 7.55857 20.2377 7.29623 19.9141 7.29623ZM8.89106 9.57197C8.78453 9.47974 8.64836 9.42896 8.50746 9.42896H1.67188V3.39001H10.3499V7.29623H10.0639C9.74035 7.29623 9.47801 7.55857 9.47801 7.88216V10.0803L8.89106 9.57197ZM19.3281 14.507H12.4923C12.3514 14.507 12.2153 14.5578 12.1087 14.6501L10.6499 15.9135V8.4681H19.3281V14.507Z",
  fill: "#23335B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.6006 10.9016H17.5707C17.8943 10.9016 18.1566 10.6393 18.1566 10.3157C18.1566 9.99208 17.8943 9.72974 17.5707 9.72974H13.6006C13.277 9.72974 13.0146 9.99208 13.0146 10.3157C13.0146 10.6393 13.277 10.9016 13.6006 10.9016Z",
  fill: "#23335B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.5707 12.0735H15.1631C14.8395 12.0735 14.5771 12.3358 14.5771 12.6594C14.5771 12.983 14.8395 13.2454 15.1631 13.2454H17.5707C17.8943 13.2454 18.1566 12.983 18.1566 12.6594C18.1566 12.3358 17.8943 12.0735 17.5707 12.0735Z",
  fill: "#23335B"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_26912_10309"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white",
  transform: "translate(0.5)"
})));

var SvgPatientMessages = function SvgPatientMessages(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPatientMessages, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/patient-messages.1caae280.svg";
export { ForwardRef as ReactComponent };